/* ILLUMAS cart drawer upgrades — works with Dawn's <cart-drawer> */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function renderDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state); if (typeof state.item_count === 'number') { var empty = state.item_count === 0; drawer.classList.toggle('is-empty', empty); var cdi = document.querySelector('cart-drawer-items'); if (cdi) cdi.classList.toggle('is-empty', empty); }
    }
    initExpressButtons();
  }

  function updateCart(updates) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTIONS, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  // "+ Add 2nd camera" button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ic-updates]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    var updates;
    try { updates = JSON.parse(btn.getAttribute('data-ic-updates')); } catch (err) { btn.disabled = false; return; }
    updateCart(updates).then(renderDrawer).catch(function () { btn.disabled = false; });
  });

  function getCfg() {
    var el = document.getElementById('ic-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (err) { return null; }
  }

  function postJSON(url, body) {
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(root() + 'cart.js').then(function (r) { return r.json(); });
  }

  // "Upgrade to 128GB": swap the 64GB bundle for Kaching's 128GB bundle, keeping the bundle discount
  async function upgradeBundle(btn) {
    var cfg = getCfg();
    if (!cfg || !cfg.upgrade) return;
    var u = cfg.upgrade;
    btn.disabled = true;
    syncing = true;
    try {
      var cart = await getCart();
      var sd = cart.items.find(function (i) { return i.variant_id === u.from; });
      var cam = cart.items.find(function (i) { return i.handle === cfg.c2 && i.properties && i.properties.__kaching_bundles; });
      if (!sd || !cam) { window.location.href = u.fallback; return; }
      var camP = JSON.parse(cam.properties.__kaching_bundles);
      var bundleId = Math.random().toString(36).slice(2, 6);
      var newCam = Object.assign({}, camP, { id: bundleId, bar: u.bar });
      var newSd = { id: bundleId, deal: camP.deal, bar: u.bar, v: camP.v, bundleProduct: u.bp };

      var remove = {};
      remove[sd.key] = 0;
      remove[cam.key] = 0;
      await postJSON('cart/update.js', { updates: remove });
      await postJSON('cart/add.js', { items: [
        { id: u.to, quantity: sd.quantity, properties: { __kaching_bundles: JSON.stringify(newSd) } },
        { id: cam.variant_id, quantity: cam.quantity, properties: { __kaching_bundles: JSON.stringify(newCam) } }
      ] });

      // Safety check: if Kaching's discount didn't apply, put the original 64GB bundle back
      var after = await getCart();
      var line = after.items.find(function (i) { return i.variant_id === u.to; });
      if (!line || !line.line_level_discount_allocations.length) {
        var undo = {};
        after.items.forEach(function (i) { if (i.variant_id === u.to || i.variant_id === cam.variant_id) undo[i.key] = 0; });
        await postJSON('cart/update.js', { updates: undo });
        await postJSON('cart/add.js', { items: [
          { id: sd.variant_id, quantity: sd.quantity, properties: sd.properties },
          { id: cam.variant_id, quantity: cam.quantity, properties: cam.properties }
        ] });
        window.location.href = u.fallback;
        return;
      }
      var sections = await fetch(window.location.pathname + '?sections=' + SECTIONS).then(function (r) { return r.json(); });
      renderDrawer({ sections: sections });
    } catch (err) {
      btn.disabled = false;
    } finally {
      setTimeout(function () { syncing = false; }, 500);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ic-upgrade]');
    if (!btn) return;
    e.preventDefault();
    upgradeBundle(btn);
  });

  // Keep the bundled SD card quantity matched to the camera quantity.
  // Only touches SD lines that carry Kaching's bundle tag; extra cards bought on their own are left alone.
  var syncing = false;
  function isBundledSd(it, cfg) {
    if (cfg.sd.indexOf(it.handle) === -1) return false;
    var p = it.properties && it.properties.__kaching_bundles;
    return !!p && p.indexOf('bundleProduct') !== -1;
  }
  function syncBundle() {
    if (syncing) return;
    var cfg = getCfg();
    if (!cfg) return;
    syncing = true;
    getCart().then(function (cart) {
      var camQty = 0;
      var sdLines = [];
      cart.items.forEach(function (it) {
        if (it.handle === cfg.c2) camQty += it.quantity;
        if (isBundledSd(it, cfg)) sdLines.push(it);
      });
      if (!sdLines.length) return;
      var sdQty = sdLines.reduce(function (n, l) { return n + l.quantity; }, 0);
      if (sdQty === camQty) return;
      var updates = {};
      if (sdQty > camQty) {
        // remove full-price (undiscounted) cards first
        var excess = sdQty - camQty;
        sdLines.sort(function (a, b) { return a.line_level_discount_allocations.length - b.line_level_discount_allocations.length; });
        sdLines.forEach(function (l) {
          if (excess <= 0) return;
          var cut = Math.min(l.quantity, excess);
          updates[l.key] = l.quantity - cut;
          excess -= cut;
        });
      } else {
        var main = sdLines[0];
        updates[main.key] = main.quantity + (camQty - sdQty);
      }
      return updateCart(updates).then(renderDrawer);
    }).finally(function () { setTimeout(function () { syncing = false; }, 800); });
  }

  // Shopify Pay / Apple Pay / PayPal buttons need re-initialising after the drawer re-renders
  function initExpressButtons() {
    if (window.Shopify && window.Shopify.StorefrontExpressButtons) {
      try { window.Shopify.StorefrontExpressButtons.initialize(); } catch (err) {}
    }
  }

  // Dawn publishes cart updates through its pub/sub helper
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      syncBundle();
      initExpressButtons();
    });
  }
})();
